import React, { useEffect, useState } from 'react';
import { connect } from "react-redux";
import { STATUS } from '../../../utils/constants';
import { useNavigate } from 'react-router-dom';
import { addRegister, editRegister, setModifiedRegister, fetchRegisterID, setRegisterID } from '../../../redux/actions/RegisterActions';
import { fetchIsos, fetchMerchants } from "../../../redux/actions/DropdownActions";
import { fetchAllTerminals } from '../../../redux/actions/TerminalActions';

import { Panel, PanelBody, PanelHeader } from "../../header/panel/panel"


const AddEditRegister = (props) => {

    const navigate = useNavigate()

    const [registerID, setRegisterID] = useState('')
    const [registerName, setRegisterName] = useState('')
    const [isoValue, setIsoValue] = useState('');
    const [merchantID, setMerchantID] = useState('')
    const [registerStatusID, setRegisterStatusID] = useState(1);
    const [generate, setGenerate] = useState(false);
    const [terminalID, setTerminalID] = useState('')
    const [isCashForDebit, setIsCashForDebit] = useState(false)


    const [registerIDError, setRegisterIDError] = useState(false)
    const [registerNameError, setRegisterNameError] = useState(false)
    const [isoError, setIsoError] = useState(false);
    const [registerStatusIDError, setRegisterStatusIDError] = useState(false);
    const [merchantError, setMerchantError] = useState(false)
    const [terminalIDError, setTerminalIDError] = useState(false)


    const [merchantDropdown, setMerchantDropdown] = useState([])
    const [terminalDropdown, setTerminalDropdown] = useState([])



    useEffect(() => {

        console.log('Clone : ' + props.REGISTERREDUCER.cloneRegister)

        if (props.edit) {
            let data = props.REGISTERREDUCER.registerData[0]
            console.log('Register Data : ', data)
            setRegisterID(data.registerID)
            setRegisterName(data.registerName)
            setIsoValue(data.isoID)
            setMerchantID(data.merchantID)
            setRegisterStatusID(data.registerStatusID)
            let merchants = props.DROPDOWNREDUCER.isosData.filter(iso => {
                return iso.isoID === data.isoID
            })
            setMerchantDropdown(merchants[0]?.merchants)
            setTerminalDropdown(props.DROPDOWNREDUCER.merchantsData)
            setTerminalID(data.terminalID)
            setIsCashForDebit(data.cashForDebit === true || data.cashForDebit === 'true' || data.cashForDebit === 1)
        } else {
            handleReset()
        }
    }, [])


    useEffect(() => {
        props.fetchIsos()
        props.fetchAllTerminals()

    }, [])

    useEffect(() => {
        setTerminalDropdown(props.DROPDOWNREDUCER.merchantsData)
    }, [props.DROPDOWNREDUCER.merchantsData])


    useEffect(() => {
        if (props.REGISTERREDUCER.registerModified) {
            props.setModifiedRegister(false)
            navigate('/register/view');
        }
    }, [props.REGISTERREDUCER])



    const handleChange = (event) => {
        let targetName = event.target.name
        let targetValue = event.target.value
        if (targetValue) {

            switch (targetName) {

                case 'registerID':
                    setRegisterID(targetValue)
                    setRegisterIDError(false)
                    break;
                case 'registerName':
                    setRegisterName(targetValue)
                    setRegisterNameError(false)
                    break;
                case 'isoID':
                    setIsoError(false)
                    setIsoValue(targetValue);
                    let merchants = props.DROPDOWNREDUCER.isosData.filter(iso => {
                        return Number(iso.isoID) === Number(targetValue) // eslint-fix: preserve loose-equality coercion
                    })
                    setMerchantDropdown(merchants[0]?.merchants)

                    break;
                case 'generate':
                    setGenerate(targetValue)
                    break;
                case 'merchantID':
                    setMerchantError(false);
                    setMerchantID(targetValue)
                    props.fetchMerchants(targetValue)
                    break;
                case 'registerStatusID':
                    setRegisterStatusIDError(false)
                    setRegisterStatusID(targetValue)
                    break
                case 'terminalID':
                    setTerminalID(targetValue)
                    setTerminalIDError(false)
                    break;
                default:
                    break;
            }

        }
    }

    // const checkSerialNumber = (event) => {
    //     props.checkSerialNumber(event.target.value)
    // }

    const handleGenerateClick = (event) => {
        setGenerate(!generate)
        setRegisterID('')
    }

    const handleCashForDebitClick = (event) => {
        setIsCashForDebit(!isCashForDebit)
    }

    // const checkTerminalID = (event) => {
    //     props.checkTerminalID(event.target.value)
    // }


    const handleSubmit = (event) => {

        event.preventDefault();

        let body = {}

        if (registerID) {
            body.registerID = registerID
        }

        if (merchantID) {
            body.merchantID = merchantID
        } else {
            setMerchantError(true)
        }

        if (registerStatusID) {
            setRegisterIDError(false);
            body.registerStatusID = registerStatusID
        } else {
            setRegisterIDError(true)
        }

        if (terminalID) {
            body.terminalID = terminalID
            setTerminalIDError(false)
        } else {
            setTerminalIDError(true)
        }
        if (registerName) {
            body.registerName = registerName
        } else {
            setRegisterNameError(true)
        }

        body.generate = generate

        body.cashForDebit = isCashForDebit

        if (registerStatusID && isoValue && merchantID && !props.edit && terminalID) {
            props.addRegister(body)
            props.setRegisterID(registerID)
        } else if (registerID && registerStatusID && isoValue && merchantID && props.edit && terminalID) {
            props.editRegister(body)
            props.setRegisterID(registerID)
        }

    }

    const handleReset = (event) => {

        setRegisterID('')
        setIsoValue('')
        setMerchantID('')
        setRegisterStatusID(1)
        setTerminalID('')
        setIsCashForDebit(false)
        setRegisterIDError(false)
        setRegisterStatusIDError(false)
        setIsoError(false)
        setMerchantError(false)
        setTerminalIDError(false)
    }

    const handleEditCancel = () => {
        navigate('/register/view');
    }

    return (

        <div className="mb-3">


            <div className="row gx-3">


                <Panel >

                    <PanelHeader>Register Form</PanelHeader>

                    <PanelBody>


                        <form className="fs-13px">

                            {props.edit ? <div className="mb-3">
                                <div className="row gx-3">
                                    <div className="col-md-3 mb-2 mb-md-0">
                                        <label className={"col-md-12 " + (registerIDError ? 'text-danger' : '')}><b>Register ID</b></label>
                                        <input type="text" className="form-control fs-13px"
                                            name="registerID"
                                            onChange={handleChange}
                                            value={registerID ? registerID : ''}
                                            disabled={props.edit}
                                        />
                                    </div>
                                </div>

                            </div> : <>
                                <div className="col-md-3 mb-2 mb-md-0">
                                    <label className={"col-md-6 " + (registerStatusIDError ? 'text-danger' : '')}><b>Generate Register ID</b></label>
                                    <input
                                        class="form-check-input"
                                        type="checkbox"
                                        name="generate"
                                        onClick={handleGenerateClick}
                                        value={generate ? generate : false}
                                    />
                                </div>
                                <div className="col-md-3 mb-2 mb-md-0">
                                    <label className={"col-md-6 " + (registerIDError ? 'text-danger' : '')}><b>Register ID</b></label>
                                    <input type="text" className="form-control fs-13px"
                                        name="terminalID"
                                        onChange={handleChange}
                                        value={registerID ? registerID : ''}
                                        disabled={generate}
                                    />
                                </div>
                            </>
                            }

                            <div className="col-md-3 mb-2 mb-md-0">

                                <label className={"col-md-6 " + (registerStatusIDError ? 'text-danger' : '')}><b>Status</b></label>

                                <select className="form-select"
                                    value={registerStatusID ? registerStatusID : 1}
                                    error={registerStatusIDError}
                                    onChange={handleChange}
                                    name='terminalStatusID'
                                >

                                    {STATUS.map((option) => (
                                        <option key={option.id} value={option.id}>
                                            {option.status}
                                        </option>
                                    ))}
                                </select>
                            </div>



                        <div className="mb-3">

                            <div className="row gx-3">
                                <div className="col-md-3 mb-2 mb-md-0">
                                    <label className={"col-md-6 " + (registerNameError ? 'text-danger' : '')}><b>Register Name</b></label>
                                    <input type="text" className="form-control fs-13px"
                                        name="registerName"
                                        onChange={handleChange}
                                        value={registerName ? registerName : ''}
                                    />
                                </div>
                                <div className="col-md-3 mb-2 mb-md-0">
                                    <label className="col-md-12"><b>Cash For Debit</b></label>
                                    <div className="form-check">
                                        <input
                                            className="form-check-input"
                                            type="checkbox"
                                            name="cashForDebit"
                                            onChange={handleCashForDebitClick}
                                            checked={isCashForDebit}
                                        />
                                    </div>
                                </div>
                            </div>

                        </div>

                        <div className="mb-3">

                            <div className="row gx-3">

                                <div className="col-md-3 mb-2 mb-md-0">

                                    <label className={"col-md-3 " + (isoError ? 'text-danger' : '')}><b>ISO</b></label>
                                    <select className="form-select"
                                        value={isoValue ? isoValue : ''}
                                        error={isoError}
                                        onChange={handleChange}
                                        name='isoID'
                                    >
                                        <option value=''>Select ISO</option>

                                        {props.DROPDOWNREDUCER.isosData.map((option) => (
                                            <option key={option.isoID} value={option.isoID}>
                                                {option.isoName}
                                            </option>
                                        ))}

                                    </select>
                                </div>
                                <div className="col-md-3 mb-2 mb-md-0">
                                    <label className={"col-md-3 " + (merchantError ? 'text-danger' : '')}><b>Merchant</b></label>

                                    <select className="form-select"
                                        value={merchantID ? merchantID : ''}
                                        error={merchantError}
                                        onChange={handleChange}
                                        name='merchantID'
                                    >

                                        <option value=''>Select Merchant</option>
                                        {merchantDropdown.map((option) => (
                                            <option key={option.merchantID} value={option.merchantID}>
                                                {option.merchantName}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                <div className="col-md-3 mb-2 mb-md-0">
                                    <label className={"col-md-3 " + (terminalIDError ? 'text-danger' : '')}><b>Merchant</b></label>
                                <select className="form-select"
                                    value={terminalID ? terminalID : ''}
                                    onChange={handleChange}
                                    name='terminalID'
                                >
                                    <option value=''>Select Terminal </option>
                                    {terminalDropdown.map((option) => (
                                        <option key={option.terminalID} value={option.terminalID}>
                                            {option.terminalID}
                                        </option>
                                    ))}

                                </select>

                                </div>

                            </div>
                        </div>


                        <div className="mb-3">

                            <div className="row gx-3">

                                <div className="col-md-3 mb-2 mb-md-0">
                                    <button className='btn btn-primary d-block w-100 btn-lg h-9px fs-13px' onClick={handleSubmit}>{props.edit ? 'Save' : 'Add'}</button>
                                </div>

                                <div className="col-md-3 mb-2 mb-md-0">

                                    {props.edit ? <button className='btn btn-gray d-block w-100 btn-lg h-9px fs-13px' onClick={handleEditCancel}>Cancel</button>
                                        : <button className='btn btn-gray d-block w-100 btn-lg h-9px fs-13px' onClick={handleReset}>Reset</button>}

                                </div>
                            </div>
                            </div>

                        </form>


                    </PanelBody >



                </Panel >
            </div>

        </div>

    )
}

function mapStateToProps(state) {
    return state
}

const mapDispatchToProps = {
    setRegisterID,
    fetchRegisterID,
    fetchMerchants,
    addRegister,
    editRegister,
    setModifiedRegister,
    fetchIsos,
    fetchAllTerminals,
}


export default connect(mapStateToProps, mapDispatchToProps)(AddEditRegister);